// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"6":"e658b538","22":"83797648","299":"b48bb1d1","908":"f80956d6"}[chunkId] + ".js";
};